import { useQuery } from '@tanstack/react-query';
import { API_PATHS } from 'api';
import httpClient from 'api/httpClient';
import { Campaign, CampaignType } from 'models/Campaign';
import { PaginatedData } from 'models/PaginatedData';

const fetchCampaigns = async (
  params: object,
): Promise<PaginatedData<Campaign>> => {
  const response = await httpClient.get(
    (params?.campaignType as CampaignType) === CampaignType.Personal
      ? API_PATHS.personalCampaigns.getCampaigns()
      : API_PATHS.campaigns.getCampaigns(),
    {
      params: { ...params, limit: 10 },
    },
  );
  return response.data;
};

const useCampaigns = (params: object) => {
  return useQuery({
    queryKey: [
      params?.campaignType === CampaignType.Personal
        ? API_PATHS.personalCampaigns.getCampaigns()
        : API_PATHS.campaigns.getCampaigns(),
      { ...params, limit: 10 },
    ],
    queryFn: () => fetchCampaigns(params),
    enabled: true,
  });
};

export default useCampaigns;
